import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-132c712f")

_pushScopeId("data-v-132c712f")
const _hoisted_1 = { class: "editor-area" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "nowrap" }
const _hoisted_4 = { class: "content-box" }
const _hoisted_5 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditTemplateCommand = _resolveComponent("EditTemplateCommand")
  const _component_EditTitle = _resolveComponent("EditTitle")
  const _component_EditArea = _resolveComponent("EditArea")
  const _component_EditCommand = _resolveComponent("EditCommand")

  return (_openBlock(), _createBlock("div", {
    class: "edit-template",
    tabindex: "1",
    onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.undo.keyHook && _ctx.undo.keyHook(...args)))
  }, [
    _createVNode(_component_EditTemplateCommand, {
      ref: "editTemplateCommand",
      editStore: _ctx.editStore,
      undo: _ctx.undo,
      onSave: _ctx.save
    }, null, 8, ["editStore", "undo", "onSave"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          class: "title-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowEditTitle = true))
        }, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.editStore?.state.editData.title), 1)
        ])
      ]),
      _createVNode(_component_EditTitle, {
        isShowModal: _ctx.isShowEditTitle,
        "onUpdate:isShowModal": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowEditTitle = $event)),
        editStore: _ctx.editStore,
        onDone: _ctx.setTitle
      }, null, 8, ["isShowModal", "editStore", "onDone"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editStore?.state.frameWithEdit, (fe) => {
            return _withDirectives((_openBlock(), _createBlock(_component_EditArea, {
              ref: _ctx.setEditArea,
              key: fe.index,
              frameOrder: fe.frame.order,
              editStore: _ctx.editStore
            }, null, 8, ["frameOrder", "editStore"])), [
              [_vShow, fe.index == _ctx.editStore?.state.selectedFrameIndex]
            ])
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_EditCommand, { editStore: _ctx.editStore }, null, 8, ["editStore"])
  ], 32))
})